import React from 'react';
import Map from '../components/Map';
import './MapPage.css';

const MapPage: React.FC = () => {
  return (
    <div className="map-page">
      <div className="map-page-header">
        <h1>Interactive Map</h1>
        <p>View all deer cull records across England on our interactive map</p>
      </div>
      <div className="map-page-content">
        <Map />
      </div>
    </div>
  );
};

export default MapPage;